<template>
  <div class="el-modal">
    <div :class="{'is-active' : isActive, 'modal': true}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <!-- Any other Bulma elements you want -->
        <b-card>
          <b-card-content>
            <slot></slot>
          </b-card-content>
        </b-card>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="toggleVisibility()"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    isActive: Boolean,
    modalName: String
  },
  methods: {
    toggleVisibility () {
      this.$emit(this.modalName + 'Active', false)
    }
  }
}
</script>
